import React, { useState } from 'react';
import { Button, Input, Space, Alert } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { deleteSection } from '../../../../config';

const FormSectionDelete = ({ data = {}, onClose }) => {
    const [disableButton, setDisableButton] = useState(true);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (event) => {
        const { value } = event.target;
        setInputValue(value);
        setDisableButton(value.toLowerCase() !== data.name.toLowerCase());
    };

    const onDeleteSection = () => {
        setLoading(true);
        deleteSection(data.sectionId)
            .then(() => {
                onClose()
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            })
    };

    return (
        <div className="w-full ">
            <div className="p-6">
                {/* Icono de advertencia */}
                <div className="flex justify-center mb-4">
                    <ExclamationCircleFilled className="text-red-500 text-4xl" />
                </div>

                {/* Título y descripción */}
                <h3 className="text-lg font-semibold text-center mb-2">Confirmar eliminación</h3>
                <p className="text-gray-600 text-center mb-6">
                    Esta acción no se puede deshacer. Se eliminará permanentemente la sección.
                </p>

                {/* Alerta de confirmación */}
                <Alert
                    message={
                        <span>
                            Escribe <span className="font-bold">{data.name.toLowerCase()}</span> para confirmar
                        </span>
                    }
                    type="warning"
                    showIcon
                    className="mb-4"
                />

                {/* Campo de entrada */}
                <Input
                    placeholder="Escriba aquí para confirmar"
                    onChange={handleInputChange}
                    value={inputValue}
                    className="mb-6"
                    status={inputValue && disableButton ? 'error' : ''}
                />

                {/* Botones de acción */}
                <Space direction="horizontal" className="w-full justify-end">
                    <Button
                        onClick={onDeleteSection}
                        type="primary"
                        danger
                        disabled={disableButton}
                        loading={loading}
                    >
                        {loading ? 'Eliminando...' : 'Eliminar'}
                    </Button>
                </Space>
            </div>
        </div>
    );
};

export default FormSectionDelete;